// extracted by mini-css-extract-plugin
module.exports = {"root":"Logo_root__3asTC"};